import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SebbieTask } from 'src/app/models/sebbietask.model';

@Component({
    selector: 'task-detail-dialog',
    templateUrl: './task-detail-dialog.component.html',
    styleUrl: './task-detail-dialog.component.scss',
    standalone: false
})
export class TaskDetailDialogComponent {
  tasknumber: number = this.data.tasknumber;
  task: SebbieTask = this.data.task;
  completedCount: number = this.data.completedCount;

  constructor(
    private readonly dialogRef: MatDialogRef<TaskDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: {
      tasknumber: number;
      task: SebbieTask;
      completedCount: number;
    },
  ) { }

  close(): void {
    this.dialogRef.close();
  }
}
